import { IStructuredNodeState, StructuredNodeDispatchT } from "../StructuredNodeContext";

type StructuredNodeReducerActionsT =
  | { type: "acceptChanges" }
  | { type: "cancelChanges" }
  | { type: "setAcceptChanges"; payload: boolean }
  | { type: "setCanDrop"; payload: boolean }
  | { type: "setEditableTitle"; payload: string }
  | { type: "setInEditMode"; payload: boolean }
  | { type: "setIsRemoving"; payload: boolean };

const structuredNodeReducer = (
  draft: IStructuredNodeState,
  action: StructuredNodeReducerActionsT
) => {
  switch (action.type) {
    case "acceptChanges": {
      draft.inEditMode = false;
      draft.isNewlyCreatedFolder = false;
      draft.originalTitle = draft.editableTitle;
      break;
    }
    case "cancelChanges": {
      draft.editableTitle = draft.originalTitle;
      draft.inEditMode = false;
      draft.isRemoving = false;
      break;
    }
    case "setIsRemoving": {
      draft.isRemoving = action.payload;
      break;
    }
    case "setCanDrop": {
      draft.canDrop = action.payload;
      break;
    }
    case "setInEditMode": {
      draft.inEditMode = action.payload;
      break;
    }
    case "setEditableTitle": {
      draft.editableTitle = action.payload;
      break;
    }

    default: {
      throw new Error("invalid structured node reducer action");
    }
  }
};

// Module functions
const acceptNodeChanges = (
  dispatch: StructuredNodeDispatchT,
  setIsTreeDraggable: (isDraggable: boolean) => void
) => {
  setIsTreeDraggable(true);
  dispatch({ type: "acceptChanges" });
};

const cancelNodeChanges = (
  dispatch: StructuredNodeDispatchT,
  setIsTreeDraggable: (isDraggable: boolean) => void
) => {
  setIsTreeDraggable(true);
  dispatch({ type: "cancelChanges" });
};

const setInEditMode = (
  dispatch: StructuredNodeDispatchT,
  payload: boolean,
  setIsTreeDraggable: (isDraggable: boolean) => void
) => {
  setIsTreeDraggable(!payload);
  dispatch({ type: "setInEditMode", payload });
};

const setCanDrop = (dispatch: StructuredNodeDispatchT, payload: boolean) =>
  dispatch({ type: "setCanDrop", payload });

export {
  acceptNodeChanges,
  cancelNodeChanges,
  setCanDrop,
  setInEditMode,
  structuredNodeReducer
};

export type { StructuredNodeReducerActionsT };
